// ConEd OAuth configuration
export const CLIENT_ID = process.env.REACT_APP_CONED_CLIENT_ID;
export const REDIRECT_URI = `https://app.golivecosmos.com`;
export const CONED_APPLICATION_ID = process.env.REACT_APP_CONED_APPLICATION_ID;

// Generate a random state string for OAuth security
export const generateRandomState = () => {
  const array = new Uint32Array(8);
  window.crypto.getRandomValues(array);
  return Array.from(array, (x) => x.toString(16)).join('');
};

// Standard scope for requesting authorization
export const getConEdScope = () => {
  return (
    'FB=1_3_4_5_7_10_15_16_51_53_56_57_58_60' +
    ';IntervalDuration=Monthly_3600_900_300' +
    ';BlockDuration=Monthly_Daily' +
    ';HistoryLength=63072000' +
    `;BR=${CONED_APPLICATION_ID}`
  );
};

// Build authorization URL
export const getConEdAuthUrl = (state: string) => {
  const baseUrl = 'https://www.coned.com/en';
  return (
    `${baseUrl}/oauth/authorize?` +
    `scope=${encodeURIComponent(getConEdScope())}` +
    `&response_type=code` +
    `&client_id=${CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
    `&state=${state}`
  );
};
